module.exports = "/desktop-app/assets/img/search.png?5725e1008621995c67d7fbce29fecf15";


//////////////////
// WEBPACK FOOTER
// ./foody/src/assets/common/images/icon/search.png
// module id = hU6U
// module chunks = 1